export default __webpack_public_path__ + "static/haloo_loader-d0553da9b824d6718eac5e2167631b1a.gif";